import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "sticky-top-20 g-catpane__body" };
const _hoisted_2 = {
    class: "title",
    style: { "padding-left": "16px", "margin-bottom": "0px" }
};
const _hoisted_3 = {
    key: 1,
    class: "ms-3 mt-2"
};
const _hoisted_4 = { class: "position-relative" };
const _hoisted_5 = {
    class: "title",
    style: { "padding-left": "16px", "margin-bottom": "16px" }
};
const _hoisted_6 = {
    key: 1,
    class: "container-sm border-bottom mb-3 pb-3"
};
const _hoisted_7 = { class: "container-sm" };
const _hoisted_8 = { class: "col-md-12" };
const _hoisted_9 = {
    class: "row g-2 align-items-stretch product-list",
    style: { "overflow-y": "auto" }
};
const _hoisted_10 = ["product"];
const _hoisted_11 = {
    key: 2,
    class: "container-sm border-top mt-3 pt-3 pb-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_g_treeview = _resolveComponent("g-treeview");
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_pager = _resolveComponent("g-pager");
    const _component_g_product_card = _resolveComponent("g-product-card");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.OnRefresh($event)))
                    }, "Aktualisieren")
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, null, {
            title: _withCtx(() => [
                _createVNode(_component_g_breadcrumb, { "show-home": true })
            ]),
            sidebar: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$tc('client.Commerce.Search.Categories')), 1),
                    (_ctx.categories && _ctx.categories.length > 0)
                        ? (_openBlock(), _createBlock(_component_g_treeview, {
                            key: 0,
                            class: "mb-4",
                            "data-source": _ctx.categories,
                            "data-structure": "plain"
                        }, null, 8, ["data-source"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$tc('client.Commerce.Search.NoCategoriesFound')), 1))
                ])
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                    (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                        : _createCommentVNode("", true),
                    _createElementVNode("h5", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Search.YourSearch')) + " ", 1),
                        _createElementVNode("b", null, "\"" + _toDisplayString(_ctx.searchText) + "\"", 1)
                    ]),
                    (_ctx.recordCount > _ctx.pageSize)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_g_pager, {
                                page: parseInt(_ctx.$route?.query?.p ?? 1),
                                records: _ctx.recordCount,
                                "page-size": _ctx.pageSize
                            }, null, 8, ["page", "records", "page-size"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: product.itemNumber,
                                        product: product,
                                        class: "col-md-6 col-xl-4 d-flex align-items-stretch"
                                    }, [
                                        _createVNode(_component_g_product_card, {
                                            product: product,
                                            mode: _ctx.search
                                        }, null, 8, ["product", "mode"])
                                    ], 8, _hoisted_10));
                                }), 128))
                            ])
                        ])
                    ]),
                    (_ctx.recordCount > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_g_pager, {
                                page: parseInt(_ctx.$route?.query?.p ?? 1),
                                records: _ctx.recordCount,
                                "page-size": _ctx.pageSize
                            }, null, 8, ["page", "records", "page-size"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        })
    ], 64));
}
